export default __webpack_public_path__ + "static/media/arrow-left-up.4c61296b.svg";